import { render } from "./PlatformEmailSettings.vue?vue&type=template&id=0dbb148a&scoped=true"
import script from "./PlatformEmailSettings.vue?vue&type=script&lang=js"
export * from "./PlatformEmailSettings.vue?vue&type=script&lang=js"

import "./PlatformEmailSettings.vue?vue&type=style&index=0&id=0dbb148a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbb148a"]])

export default __exports__